import React, { useState, useContext } from "react"
import {
    Container,
    Form,
    Input,
    Button,
    Message
} from "semantic-ui-react"
import {
    UserContext,
    apiUrl
  } from '@dialectic-design/hyperobjects-user-context'
import _ from "lodash"

const NewScriptPage = () => {
    const user = useContext(UserContext)
    const [newScriptName, setNewScriptName] = useState("")
    const [error, setError] = useState(false)
    const [success, setSuccess] = useState(false)
    return (
        <div className="new-script-page">
            <Container>
            <h2>New script</h2>
            {success ? (
                <Message positive>
                    Script successfully created.
                </Message>
            ) : (
                <div className='ui form'>
                    <Form.Field>
                        <label>Script name</label>
                        <Input
                            placeholder="script name..."
                            value={newScriptName}
                            onChange={(e) => {
                                setNewScriptName(e.target.value)
                                if(error === "Set a name." && e.target.value.length > 0) {
                                    setError(false)
                                }
                            }}
                            />
                    </Form.Field>
                    <Form.Field>
                        <Button
                            onPointerDown={() => {
                                if(newScriptName.length === 0) {
                                    setError("Set a name.")
                                } else {
                                    fetch(apiUrl + `/admin/script`, {
                                        method: "POST",
                                        headers: {
                                            "Authorization": `Bearer ${user.token}`,
                                            "Content-Type":"application/json"
                                        },
                                        credentials: "include",
                                        body: JSON.stringify({
                                            name: newScriptName
                                        })
                                    }).then(resp => {
                                        if(resp.status === 200) {
                                            setSuccess(true)
                                        } else {
                                            resp.json().then(data => {
                                                console.log(data)
                                                setError(_.get(data, "message", 'unknown error'))
                                            })
                                        }
                                    })
                                }
                            }}
                            >
                            Create
                        </Button>
                    </Form.Field>
                    {error && (
                        <Message negative>
                            {error}
                        </Message>
                    )}
                </div>
            )}
            
            </Container>
        </div>
    )
}

export default NewScriptPage